import React from 'react';
import { withTheme } from 'styled-components';

import { StyledGoBackButton } from './go-back-button.styles';

const GoBackButton = ({ href, theme }) => {
  return (
    <StyledGoBackButton href={href} title="Назад к странице документа в ЭБ">
      <svg
        width="7"
        height="13"
        viewBox="0 0 7 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 1L1 6.5L6 12"
          stroke={theme.themeColors.controlBar.leftPanel.goBackButtonColor}
          strokeLinecap="round"
        />
      </svg>
      <span>
        Назад
      </span>
    </StyledGoBackButton>
  );
};

export default withTheme(GoBackButton);
